import Box from "@mui/material/Box"
import CircularProgress from "@mui/material/CircularProgress"

export default function CircularSkeleton({ size = 50 }) {
	return (
		<Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", p: 2 }}>
			<CircularProgress size={size} />
		</Box>
	)
}
